import { createSlice } from "@reduxjs/toolkit";
import { createPackage, getPackage, getPackageById, getPublicPackage, updatePackage, deletePackage } from "../actions/packageActionsHelper";
import { packagesObject } from "../stateObject/packagesObject";

const initialState = packagesObject;

const packageSlice = createSlice({
    name: "package",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
        resetState: () => {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPackage.request, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getPackage.success, (state, action) => {
                state.packages = action.payload;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(getPackage.failed, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Failed to fetch packages.";
            })
            .addCase(getPackageById.request, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getPackageById.success, (state, action) => {
                state.selectedPackage = action.payload;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(getPackageById.failed, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Failed to fetch package.";
            })
            .addCase(createPackage.request, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createPackage.success, (state, action) => {
                state.packageData = action.payload;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(createPackage.failed, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Package creation failed. Please try again.";
            })
            .addCase(updatePackage.request, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updatePackage.success, (state, action) => {
                state.packageData = action.payload;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(updatePackage.failed, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Package update failed. Please try again.";
            })
            .addCase(deletePackage.request, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(deletePackage.success, (state, action) => {
                state.packageData = action.payload;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(deletePackage.failed, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Package deletion failed. Please try again.";
            })
            .addCase(getPublicPackage.request, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getPublicPackage.success, (state, action) => {
                state.publicPackages = action.payload;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(getPublicPackage.failed, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Failed to fetch public packages.";
            });
    },
});

export const { setLoading, clearError, resetState: resetPackageState } = packageSlice.actions;
export default packageSlice.reducer;
